export default function auth ({ next }) {
  if (localStorage.getItem('token') == null) {
    return next({
      name: 'Signin'
    })
  }

  return next()
}



// WEBPACK FOOTER //
// ./src/middleware/auth.js